import { SDK_STREAM_TIMEOUT_MS } from '@repo/config';
import { postRawRequest } from '../../httpClient';
import type { IClipSubtitleV1Params } from './clip-subtitle-v1-request';

export async function clipSubtitleV1Api({
  subtitleId,
  force,
}: IClipSubtitleV1Params): Promise<Response> {
  const params: string[] = [];
  if (force) {
    params.push('force=true');
  }
  const query = params.length > 0 ? `?${params.join('&')}` : '';
  return postRawRequest({
    path: `/sys/subtitles/${subtitleId}/clip/v1${query}`,
    options: { timeout: SDK_STREAM_TIMEOUT_MS },
  });
}
